import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en from './en'
import es from './es'
import cat from './cat'

// Import modules
import pdfViewMessages from './modules/facturae/pdf_view'

Vue.use(VueI18n)

// Function to deeply merge translation objects
function deepMerge(target, source) {
  for (const key in source) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
      target[key] = target[key] || {}
      deepMerge(target[key], source[key])
    } else {
      target[key] = source[key]
    }
  }
  return target
}

// Merge global translations with module translations
const messages = {
  en: deepMerge({ ...en }, pdfViewMessages.en),
  es: deepMerge({ ...es }, pdfViewMessages.es),
  cat: deepMerge({ ...cat }, pdfViewMessages.cat),
}


// Try to get browser language or use 'es' as default
function getBrowserLanguage() {
  const userLang = navigator.language || navigator.userLanguage
  const lang = userLang.split('-')[0]
  return messages[lang] ? lang : 'es'
}

// Create VueI18n instance with options
// Default to Spanish - will be changed by App.vue based on feature flags
const i18n = new VueI18n({
  locale: localStorage.getItem('locale') || 'es',
  messages,
  silentTranslationWarn: true // Avoid console warnings for missing translations
})

export default i18n
